<template >
  <div class="ml-3 mr-2">
    <Dash  :nome_utente_sel="nome_utente_sel" />
  </div>
</template>
<style scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.colore_card_utente {
  background: linear-gradient(
    118deg,
    rgba(92, 107, 192, 1),
    rgba(123, 136, 212, 0.7)
  ) !important;
}
</style>
<script>
import Dash from "../../components/MEDICAL/Dash";
export default {
  components: {
    Dash,
  },
  mounted() {
    this.getDatiUtente();
  },
  data: () => ({
    id_profilo: null,
    utente_sel: null,
    nome_utente_sel: localStorage.nominativo,
  }),
  methods: {
    indietro() {
      console.log();
      this.utente_sel = null;
      localStorage.removeItem("id_user_sel");
      localStorage.removeItem("nominativo_sel");
      localStorage.removeItem("arrivo");
    },
    selezionaUtente(item) {
      if (this.id_profilo != 7 && this.id_profilo != 8) {
        console.log(item);
        this.utente_sel = item.id_utente;
        this.nome_utente_sel = item.nominativo;
        localStorage.setItem("id_user_sel", item.id_utente);
        localStorage.setItem("nominativo_sel", item.nominativo);
        localStorage.setItem("arrivo", "dash");
      }
    },
    getDatiUtente() {
      if (localStorage.id_user_sel != undefined) {
        this.utente_sel = localStorage.id_user_sel;
        this.nome_utente_sel = localStorage.nominativo_sel;
      }
      this.id_profilo = parseInt(localStorage.id_profilo);
      console.log(this.id_profilo);
    },
  },
};
</script>